export default {
    // Queue.vue translations
    queue: {
        statuses: {
            open: 'Open',
            accepted: 'Accepted',
        },
        showDisposed: 'Show Disposed',
        hideDisposed: 'Hide Disposed',
        tableHeaders: {
            view: 'View',
            leadStatus: 'Status',
            companyName: 'Company Name',
            linkedin: 'LinkedIn',
            submittedBy: 'Submitted By',
            msRep: 'MS Rep',
            offer: 'Offer',
            commission: 'Commission %',
            upfront: 'Upfront',
            acceptedAt: 'Accepted At',
            qualified: 'Qualified',
            paid: 'Paid',
            dispose: 'Dispose',
            companySize: 'Company Size',
            businessType: 'Business Type',
            icpFitRank: 'ICP Fit Rank',
            icpVerified: 'ICP Verified',
            briefed: 'Briefed',
            decisionMaker: 'Decision Maker',
            appointmentSet: 'Appointment Set',
            created: 'Created',
        },
        viewLead: 'View Lead',
        viewLinkedIn: 'Open LinkedIn profile',
        viewLinkedInForCompany: 'Open LinkedIn profile for {company}',
        showingResults: 'Showing {from} to {to} of {total} results',
        errors: {
            qualified: 'Failed to update qualification status',
            paid: 'Failed to update payment status',
            disposed: 'Failed to update disposed status',
            networkError: 'Unable to connect to the server. Please check your internet connection.',
            unexpectedError: 'An unexpected error occurred. Please try again.',
        },
    },

    // Index.vue translations
    index: {
        title: 'Submit a Lead. Get an Instant Offer.',
        subtitle: "We'll calculate what your lead is worth. You'll pick your payout — fast, automatic, and based on verified lead quality.",
        form: {
            sections: {
                leadDetails: 'Lead Details',
                qualification: 'Qualification',
            },
            companyName: 'Company Name',
            companyWebsite: 'Company Website',
            linkedinProfileUrl: 'Decision Maker LinkedIn Profile URL',
            linkedinOptional: 'Optional. Leave blank if unavailable.',
            briefedQuestion: 'Has the decision maker confirmed interest in MarketScale?',
            briefedNote: 'This means: after you explain MarketScale, they say "Yes, I want to talk." If they haven\'t said yes, select No.',
            decisionMakerQuestion: 'Is this your direct introduction to the decision maker?',
            decisionMakerNote: 'Can they make the final decision without asking anyone else for approval?',
            meetingConfirmed: 'Is the meeting confirmed with a calendar invite?',
            meetingTooltip: '<strong>"Calendar Invite"</strong> means a verifiable, time-stamped digital meeting invitation created through a recognized calendar platform (such as Outlook, Google Calendar, or Microsoft Teams) that includes the following:<br><br><strong>1. Date and Time</strong> of the scheduled meeting<br><strong>2. Participants</strong> — including a MarketScale representative and the referred prospect<br><strong>3. Meeting link or location</strong><br><strong>4. Acceptance record</strong> showing that both parties (MarketScale and the prospect) have accepted or confirmed attendance through the platform\'s built-in acceptance feature (e.g., "Accepted" status in Outlook or Google Calendar)',
            note: 'Have they accepted a scheduled meeting invite? If so, set the date below.',
            noAppointmentDescription: 'Describe the introduction and next steps, or copy your introduction and conversation here.',
            acknowledgment: 'I confirm this information is accurate. I understand that payment is processed automatically based on verified submission data.',
            yes: 'Yes',
            no: 'No',
            showOfferOptions: 'Get My Offer',
        },
        errors: {
            companyWebsiteRequired: 'Company website is required',
            linkedinProfileUrlInvalid: 'Enter a valid LinkedIn URL or leave this field blank.',
            appointmentDateRequired: 'Please select an appointment date.',
            noAppointmentDescriptionRequired: 'Please provide a description of at least 150 characters describing the introduction and next steps.',
            acknowledgmentRequired: 'You must acknowledge the terms before submitting',
        },
        loading: {
            reviewingSignals: 'Reviewing company signals and market fit...',
            evaluatingAccess: 'Evaluating lead access and decision authority...',
            scoringIcp: 'Scoring ICP fit and confirming payout...',
        },
        viewLeadsButton: 'View My Leads',
    },

    // OfferPreview.vue translations
    offerPreview: {
        title: 'Your Dynamic Offer',
        subtitle: 'Choose your payment.',
        tooltip: 'The offer dynamically adjusts based on lead quality. Stronger signals like ICP fit, appointment set, decision maker access, and business tier increase upfront payment.',
        badges: {
            decisionMaker: 'Decision Maker',
            appointmentSet: 'Appointment Set',
            icpVerified: 'ICP Verified',
        },
        sliders: {
            commission: 'Commission',
            upfrontPayment: 'Upfront Payment',
            upfrontTooltip: 'Must have shown interest first for Upfront payment',
        },
        buttons: {
            claimOffer: 'Claim Your Offer',
            offerSubmitted: 'Offer Accepted',
            submitting: 'Submitting...',
            backToHome: 'Back to Home',
        },
        errors: {
            somethingWentWrong: 'Something went wrong',
        },
    },
}
